// tabs
// CONCATENATED MODULE: ./src/components/tabs.js
function tabs_toConsumableArray(arr) { return tabs_arrayWithoutHoles(arr) || tabs_iterableToArray(arr) || tabs_unsupportedIterableToArray(arr) || tabs_nonIterableSpread(); }
function tabs_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function tabs_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return tabs_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return tabs_arrayLikeToArray(o, minLen); }
function tabs_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function tabs_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return tabs_arrayLikeToArray(arr); }
function tabs_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function tabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function tabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tabs_ownKeys(Object(source), !0).forEach(function (key) { tabs_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function tabs_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function tabs_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function tabs_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function tabs_createClass(Constructor, protoProps, staticProps) { if (protoProps) tabs_defineProperties(Constructor.prototype, protoProps); if (staticProps) tabs_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var tabs_Default = {
    defaultTabId: null,
    activeClasses: '#FF512F',
    inactiveClasses: '#B0B0B0',
    onShow: function onShow() { }
};
var Tabs = /*#__PURE__*/function () {
    function Tabs() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        tabs_classCallCheck(this, Tabs);
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = tabs_objectSpread(tabs_objectSpread({}, tabs_Default), options);
        this._init();
    }
    tabs_createClass(Tabs, [{
        key: "_init",
        value: function _init() {
            var _this = this;
            if (this._items.length) {
                // set the first tab as active if not set by explicitly
                if (!this._activeTab) {
                    this._setActiveTab(this._items[0]);
                } // force show the first default tab
                this.show(this._activeTab.id, true); // show tab content based on click
                this._items.map(function (tab) {
                    tab.triggerEl.addEventListener('click', function () {
                        _this.show(tab.id);
                        // refreshslider add
                    });
                });
            }
        }
    }, {
        key: "getActiveTab",
        value: function getActiveTab() {
            return this._activeTab;
        }
    }, {
        key: "_setActiveTab",
        value: function _setActiveTab(tab) {
            this._activeTab = tab;
        }
    }, {
        key: "getTab",
        value: function getTab(id) {
            return this._items.filter(function (t) {
                return t.id === id;
            })[0];
        }
    }, {
        key: "show",
        value: function show(id) {
            var _this2 = this,
                _tab$triggerEl$classL,
                _tab$triggerEl$classL2;
            var forceShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var tab = this.getTab(id); // don't do anything if already active
            if (tab === this._activeTab && !forceShow) {
                return;
            } // hide other tabs
            this._items.map(function (t) {
                if (t !== tab) {
                    var _t$triggerEl$classLis, _t$triggerEl$classLis2;
                    (_t$triggerEl$classLis = t.triggerEl.classList).remove.apply(_t$triggerEl$classLis, tabs_toConsumableArray(_this2._options.activeClasses.split(" ")));
                    (_t$triggerEl$classLis2 = t.triggerEl.classList).add.apply(_t$triggerEl$classLis2, tabs_toConsumableArray(_this2._options.inactiveClasses.split(" ")));
                    t.targetEl.classList.add('hidden');
                    t.triggerEl.setAttribute('aria-selected', false);
                }
            }); // show active tab
            (_tab$triggerEl$classL = tab.triggerEl.classList).add.apply(_tab$triggerEl$classL, tabs_toConsumableArray(this._options.activeClasses.split(" ")));
            (_tab$triggerEl$classL2 = tab.triggerEl.classList).remove.apply(_tab$triggerEl$classL2, tabs_toConsumableArray(this._options.inactiveClasses.split(" ")));
            tab.triggerEl.setAttribute('aria-selected', true);
            tab.targetEl.classList.remove('hidden');
            this._setActiveTab(tab); // callback function
            this._options.onShow(this, tab);
        }
    }]);
    return Tabs;
}();
window.Tabs = Tabs;
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tabs-toggle]').forEach(function (triggerEl) {
        var tabElements = [];
        var defaultTabId = null;
        triggerEl.querySelectorAll('[role="tab"]').forEach(function (el) {
            var isActive = el.getAttribute('aria-selected') === 'true';
            var tab = {
                id: el.getAttribute('data-tabs-target'),
                triggerEl: el,
                targetEl: document.querySelector(el.getAttribute('data-tabs-target'))
            };
            tabElements.push(tab);
            if (isActive) {
                defaultTabId = tab.id;
            }
        });
        new Tabs(tabElements, {
            defaultTabId: defaultTabId
        });
    });
});
/* harmony default export */ const tabs = (Tabs);
;
// tabs
// accordion
// UNUSED EXPORTS: default
// CONCATENATED MODULE: ./src/components/accordion.js
function _toConsumableArray(arr) {
    return (
        _arrayWithoutHoles(arr) ||
        _iterableToArray(arr) ||
        _unsupportedIterableToArray(arr) ||
        _nonIterableSpread()
    );
}
function _nonIterableSpread() {
    throw new TypeError(
        "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (
        (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
        iter["@@iterator"] != null
    )
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
    }
    return arr2;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly &&
            (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })),
            keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2
            ? ownKeys(Object(source), !0).forEach(function (key) {
                _defineProperty(target, key, source[key]);
            })
            : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    target,
                    Object.getOwnPropertyDescriptors(source)
                )
                : ownKeys(Object(source)).forEach(function (key) {
                    Object.defineProperty(
                        target,
                        key,
                        Object.getOwnPropertyDescriptor(source, key)
                    );
                });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
}
var Default = {
    alwaysOpen: false,
    activeClasses: "activated flex flex-row justify-between items-center",
    inactiveClasses: "w-full",
    onOpen: function onOpen() { },
    onClose: function onClose() { },
    onToggle: function onToggle() { },
};
var Accordion = /*#__PURE__*/ (function () {
    function Accordion() {
        var items =
            arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Accordion);
        this._items = items;
        this._options = _objectSpread(_objectSpread({}, Default), options);
        this._init();
    }
    _createClass(Accordion, [
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                if (this._items.length) {
                    // show accordion item based on click
                    this._items.map(function (item) {
                        if (item.active) {
                            _this.open(item.id);
                        }
                        item.triggerEl.addEventListener("click", function () {
                            _this.toggle(item.id);
                        });
                    });
                }
            },
        },
        {
            key: "getItem",
            value: function getItem(id) {
                return this._items.filter(function (item) {
                    return item.id === id;
                })[0];
            },
        },
        {
            key: "open",
            value: function open(id) {
                var _this2 = this,
                    _item$triggerEl$class,
                    _item$triggerEl$class2;
                var item = this.getItem(id); // don't hide other accordions if always open
                if (!this._options.alwaysOpen) {
                    this._items.map(function (i) {
                        if (i !== item) {
                            var _i$triggerEl$classLis, _i$triggerEl$classLis2;
                            (_i$triggerEl$classLis = i.triggerEl.classList).remove.apply(
                                _i$triggerEl$classLis,
                                _toConsumableArray(_this2._options.activeClasses.split(" "))
                            );
                            (_i$triggerEl$classLis2 = i.triggerEl.classList).add.apply(
                                _i$triggerEl$classLis2,
                                _toConsumableArray(_this2._options.inactiveClasses.split(" "))
                            );
                            i.targetEl.classList.add("hidden");
                            i.triggerEl.setAttribute("aria-expanded", false);
                            i.active = false;
                            // remove rotate from image
                            var closeImage = i.triggerEl.querySelector("img");
                            if (closeImage) {
                                closeImage.classList.remove("rotate-180");
                            }
                        }
                    });
                }
                // show active item
                (_item$triggerEl$class = item.triggerEl.classList).add.apply(
                    _item$triggerEl$class,
                    _toConsumableArray(this._options.activeClasses.split(" "))
                );
                (_item$triggerEl$class2 = item.triggerEl.classList).remove.apply(
                    _item$triggerEl$class2,
                    _toConsumableArray(this._options.inactiveClasses.split(" "))
                );
                item.triggerEl.setAttribute("aria-expanded", true);
                item.targetEl.classList.remove("hidden");
                item.active = true;
                // add rotate to image
                var openImage = item.triggerEl.querySelector("img");
                if (openImage) {
                    openImage.classList.add("rotate-180");
                }
                // callback function
                this._options.onOpen(this, item);
            },
        }
        ,
        {
            key: "toggle",
            value: function toggle(id) {
                var item = this.getItem(id);
                if (item.active) {
                    this.close(id);
                } else {
                    this.open(id);
                } // callback function
                this._options.onToggle(this, item);
            },
        },
        {
            key: "close",
            value: function close(id) {
                var _item$triggerEl$class3, _item$triggerEl$class4;
                var item = this.getItem(id);
                (_item$triggerEl$class3 = item.triggerEl.classList).remove.apply(
                    _item$triggerEl$class3,
                    _toConsumableArray(this._options.activeClasses.split(" "))
                );
                (_item$triggerEl$class4 = item.triggerEl.classList).add.apply(
                    _item$triggerEl$class4,
                    _toConsumableArray(this._options.inactiveClasses.split(" "))
                );
                item.targetEl.classList.add("hidden");
                item.triggerEl.setAttribute("aria-expanded", false);
                item.active = false;
                // remove rotate from image
                var closeImage = item.triggerEl.querySelector("img");
                if (closeImage) {
                    closeImage.classList.remove("rotate-180");
                }
                // callback function
                this._options.onClose(this, item);
            }
        },
    ]);
    return Accordion;
})();
window.Accordion = Accordion;
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-accordion]").forEach(function (accordionEl) {
        var alwaysOpen = accordionEl.getAttribute("data-accordion");
        var activeClasses = accordionEl.getAttribute("data-active-classes");
        var inactiveClasses = accordionEl.getAttribute("data-inactive-classes");
        var items = [];
        accordionEl
            .querySelectorAll("[data-accordion-target]")
            .forEach(function (el) {
                var item = {
                    id: el.getAttribute("data-accordion-target"),
                    triggerEl: el,
                    targetEl: document.querySelector(
                        el.getAttribute("data-accordion-target")
                    ),
                    iconEl: el.querySelector("[data-accordion-icon]"),
                    active: el.getAttribute("aria-expanded") === "true" ? true : false,
                };
                items.push(item);
            });
        new Accordion(items, {
            alwaysOpen: alwaysOpen === "open" ? true : false,
            activeClasses: activeClasses ? activeClasses : Default.activeClasses,
            inactiveClasses: inactiveClasses
                ? inactiveClasses
                : Default.inactiveClasses,
        });
    });
});
/* harmony default export */ const accordion = Accordion; // CONCATENATED MODULE: ./src/components/collapse.js
function collapse_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly &&
            (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })),
            keys.push.apply(keys, symbols);
    }
    return keys;
}
function collapse_objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2
            ? collapse_ownKeys(Object(source), !0).forEach(function (key) {
                collapse_defineProperty(target, key, source[key]);
            })
            : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    target,
                    Object.getOwnPropertyDescriptors(source)
                )
                : collapse_ownKeys(Object(source)).forEach(function (key) {
                    Object.defineProperty(
                        target,
                        key,
                        Object.getOwnPropertyDescriptor(source, key)
                    );
                });
    }
    return target;
}
function collapse_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function collapse_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function collapse_defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function collapse_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) collapse_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) collapse_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", { writable: false });
    return Constructor;
}
var collapse_Default = {
    triggerEl: null,
    onCollapse: function onCollapse() { },
    onExpand: function onExpand() { },
    onToggle: function onToggle() { },
};
var Collapse = /*#__PURE__*/ (function () {
    function Collapse() {
        var targetEl =
            arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 ? arguments[1] : undefined;
        collapse_classCallCheck(this, Collapse);
        this._targetEl = targetEl;
        this._triggerEl = options ? options.triggerEl : collapse_Default.triggerEl;
        this._options = collapse_objectSpread(
            collapse_objectSpread({}, collapse_Default),
            options
        );
        this._visible = false;
        this._init();
    }
    collapse_createClass(Collapse, [
        {
            key: "_init",
            value: function _init() {
                var _this = this;
                if (this._triggerEl) {
                    if (this._triggerEl.hasAttribute("aria-expanded")) {
                        this._visible =
                            this._triggerEl.getAttribute("aria-expanded") === "true"
                                ? true
                                : false;
                    } else {
                        // fix until v2 not to break previous single collapses which became dismiss
                        this._visible = this._targetEl.classList.contains("hidden")
                            ? false
                            : true;
                    }
                    this._triggerEl.addEventListener("click", function () {
                        _this._visible ? _this.collapse() : _this.expand();
                    });
                }
            },
        },
        {
            key: "collapse",
            value: function collapse() {
                this._targetEl.classList.add("hidden");
                if (this._triggerEl) {
                    this._triggerEl.setAttribute("aria-expanded", "false");
                }
                this._visible = false; // callback function
                this._options.onCollapse(this);
            },
        },
        {
            key: "expand",
            value: function expand() {
                this._targetEl.classList.remove("hidden");
                if (this._triggerEl) {
                    this._triggerEl.setAttribute("aria-expanded", "true");
                }
                this._visible = true; // callback function
                this._options.onExpand(this);
            },
        },
        {
            key: "toggle",
            value: function toggle() {
                if (this._visible) {
                    this.collapse();
                } else {
                    this.expand();
                }
            },
        },
    ]);
    return Collapse;
})();
window.Collapse = Collapse;
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll("[data-collapse-toggle]")
        .forEach(function (triggerEl) {
            var targetEl = document.getElementById(
                triggerEl.getAttribute("data-collapse-toggle")
            );
            new Collapse(targetEl, {
                triggerEl: triggerEl,
            });
        });
});
/* harmony default export */ const collapse = Collapse;
// accordion
// Function to set responsive width and height attributes for images with lazy loading and auto-filled alt text
function setResponsiveImgAttributes(img) {
    var imageUrl = img.getAttribute("src");
    var dataSrc = img.getAttribute("data-src"); // Assuming data-src attribute contains the actual image URL
    var tempImg = new Image();
    tempImg.src = imageUrl || dataSrc;
    tempImg.onload = function () {
        var imgWidth = tempImg.width;
        var imgHeight = tempImg.height;
        img.width = imgWidth;
        img.height = imgHeight;
        var fileName = imageUrl.split("/").pop().split(".")[0]; // Extract file name without extension
        img.alt = fileName; // Set alt attribute with the file name
    };
    tempImg.onerror = function () {
        console.error("Error loading image: " + (imageUrl || dataSrc));
    };
    img.loading = "eager"; // Set loading attribute to eager (can use 'lazy' if preferred)
}
// Get all img elements on the page
var imgElements = document.getElementsByTagName("img");
// Loop through all img elements and set responsive attributes with lazy loading and auto-filled alt text
for (let i = 0; i < imgElements.length; i++) {
    setResponsiveImgAttributes(imgElements[i]);
}
window.addEventListener("DOMContentLoaded", (event) => {
    // Select all <a> and <button> elements on the page
    const anchors = document.querySelectorAll("a");
    const buttons = document.querySelectorAll("button");
    // Function to set aria-label for <a> elements
    anchors.forEach((a) => {
        // Check if aria-label is missing
        if (!a.hasAttribute("aria-label")) {
            // If the anchor has text content, use that as aria-label
            if (a.textContent.trim() !== "") {
                a.setAttribute("aria-label", a.textContent.trim());
            } else {
                // If the anchor has no text, you can use the href value as aria-label or fallback to a default label
                const hrefValue = a.getAttribute("href") || "Link";
                a.setAttribute("aria-label", `Link to ${hrefValue}`);
            }
        }
    });
    // Function to set aria-label for <button> elements
    buttons.forEach((button) => {
        // Check if aria-label is missing
        if (!button.hasAttribute("aria-label")) {
            // If the button has text content, use that as aria-label
            if (button.textContent.trim() !== "") {
                button.setAttribute("aria-label", button.textContent.trim());
            } else {
                // Fallback if the button has no text content
                button.setAttribute("aria-label", "Button");
            }
        }
    });
});
function openModal(e) {
    modal = document.getElementById(e),
        modal.classList.remove("hidden")
}
function closeModal(e) {
    modal = document.getElementById(e),
        modal.classList.add("hidden")
}
document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-button");
    const tabContents = document.querySelectorAll(".tab-content");
    // Set first tab as active by default
    if (tabButtons.length > 0 && tabContents.length > 0) {
        tabButtons[0].classList.add("active");
        tabContents[0].classList.remove("hidden");
    }
    // Add click listener to each tab button
    tabButtons.forEach(button => {
        button.addEventListener("click", function () {
            const targetContent = document.querySelector(this.getAttribute("data-tab-target"));
            // Hide all contents
            tabContents.forEach(content => {
                content.classList.add("hidden");
            });
            // Remove active state from all buttons
            tabButtons.forEach(btn => {
                btn.classList.remove("active");
            });
            // Show the selected tab and mark button as active
            if (targetContent) {
                targetContent.classList.remove("hidden");
                this.classList.add("active");
            }
        });
    });
});
// Function to animate the counter numbers
function animateCounter(el, target, duration = 2000) {
    let start = 0;
    let startTime = null;
    function updateCounter(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        el.textContent = Math.floor(progress * (target - start) + start);
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        }
    }
    requestAnimationFrame(updateCounter);
}
// Run after the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
    const counters = document.querySelectorAll(".counter");
    // Use IntersectionObserver to trigger animation when visible
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const target = parseInt(el.getAttribute("data-counter"), 10);
                    // Reset counter when visible again
                    el.textContent = "0";
                    animateCounter(el, target);
                }
            });
        },
        { threshold: 0.5 } // Trigger when 50% visible
    );
    // Observe each counter element
    counters.forEach((counter) => observer.observe(counter));
});
